import { Badge, Flex, useMantineTheme } from '@mantine/core';
import React from 'react';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.tsx';

export const SelectedSubjectBadge = ({
	id,
	name,
	onRemove,
}: {
	id: string;
	name: string;
	onRemove?: (id: string) => void;
}) => {
	const theme = useMantineTheme();

	return (
		<Badge
			variant="outline"
			color="dark.4"
			size="lg"
			styles={{
				root: {
					padding: '0.25rem 0.5rem',
					borderColor: theme.colors.gray[4],
				},
				inner: {
					fontWeight: 400,
					color: theme.colors.dark[4],
					whiteSpace: 'nowrap',
				},
			}}
			rightSection={onRemove ? <Icon variant="close" onClick={() => onRemove(id)} /> : null}
		>
			{name}
		</Badge>
	);
};

export const SelectedSubjectsList = ({
	selectedIds,
	options,
	onRemove,
}: {
	selectedIds: string[];
	options: { value: string; label: string }[];
	onRemove: (id: string) => void;
}) => {
	if (!selectedIds?.length) {
		return null;
	}

	return (
		<Flex gap="xs" wrap="wrap">
			{selectedIds.map((id) => {
				const option = options.find((o) => o.value === id);

				if (!option) {
					return null;
				}

				return (
					<SelectedSubjectBadge
						key={id}
						id={id}
						name={option.label}
						onRemove={onRemove}
					/>
				);
			})}
		</Flex>
	);
};
